<template>
    <div class="alert alert-success" role="alert" v-if="message">
        {{ message }}
    </div>
    <form class="form-group" @submit.prevent="resetPassword">
        <!--<input type="hidden" name="token" value="{{ $token }}">-->
        <div class="form-group">
            <input 
                id="email" 
                type="email" 
                class="col-md-12 col-form-label"
                :class="{'has-error': resetForm.errors.has('email')}"
                name="email" 
                v-model="resetForm.email" 
                required 
                autocomplete="email" 
                autofocus 
                :pattern="email_pattern"
                :placeholder="$t('login.email')">
            <span class="fa fa-envelope form-control-feedback symbol-input"></span>
            <HasError :form="resetForm" field="email"></HasError>
        </div>

        <div class="form-group row mb-0">
            <div class="col col-12 ">
                <button type="submit" class="btn btn-primary btn-block text-center slide-btn" :disabled="loading">
                    {{ $t('password.reset_submit') }}
                </button>
            </div>
        </div>
    </form>
    <div class="text-center w-full">
        <p>
            <router-link :to="{name: 'login'}" class="txt1">
                <i class="fa fa-long-arrow-left"></i>&nbsp;{{ $t('login.sign_in2') }}
            </router-link>
        </p>
    </div>
</template>
<script>
    export default {
        name: 'RequestPasswordResetForm',
        data() {
            return {
                resetForm: new Form({
                    email: ''
                }),
                message: '',
                loading: false
            };
        }
        , components:{
            
        }
        , created() {

        }
        , mounted() {
//            console.log('Register.vue');
        }
        , methods: {
            resetPassword(){
                let url = '/password/email';
                this.loading = true;
                this.resetForm.lang = window.langKey;
                this.resetForm.post(url)
                .then(response => {
                    if(response.status === 200){
                        this.message = response.data.message;
                    }
                }).catch(function (error) {

                });
                this.loading = false;
            }
        }
    }
</script>